export default function FooterSectionTwo(){
    return(
        <div className="p-6 border-t md:px-10 px-5">
            <h1 className="text-[#565656] text-base font-normal	leading-6 text-center">© Copyrights 2023 SLSPro App All rights reserved.</h1>
        </div>
    )
}